<template>
  <vs-chip :color="badgeContext">{{ badgeContent }}</vs-chip>
</template>

<script>
export default {
  name: 'BadgeSmsType',
  props: {
    content: {
      type: [String, Number],
      required: true
    }
  },
  computed: {
    badgeContent () {
      switch (this.content) {
      case 1:
        return 'SMS'
      case 2:
        return 'LMS'
      }
      return '--'
    },
    badgeContext () {
      switch (this.content) {
      case 1:
        return 'success'
      case 2:
        return 'primary'
      }
      return '--'
    }
  }
}
</script>

<style scoped>

</style>
